import Icons from 'icons/sidebar';
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import LocalMallOutlinedIcon from '@mui/icons-material/LocalMallOutlined';
import ReceiptLongRoundedIcon from '@mui/icons-material/ReceiptLongRounded';
import ApartmentIcon from '@mui/icons-material/Apartment';
import LocalLibraryIcon from '@mui/icons-material/LocalLibrary';
import QrCodeIcon from '@mui/icons-material/QrCode';

const index = [
    {
        title: 'Dashboard',
        Icon: Icons.DashboardIcon,
        path: '/dashboard',
        role: ['member'],
    },
    {
        title: 'My QR',
        Icon: QrCodeIcon,
        path: '/dashboard/my-qr',
        role: ['member'],
    },
    {
        title: 'Buy Package',
        Icon: LocalMallOutlinedIcon,
        path: '/dashboard/choose-package',
        role: ['member'],
    },
    {
        title: 'Buy Workshops',
        Icon: LocalLibraryIcon,
        path: '/dashboard/choose-additional-workshop',
        role: ['member'],
    },
    {
        title: 'My Invoice',
        Icon: ReceiptLongRoundedIcon,
        path: '/dashboard/my-invoice',
        role: ['member'],
    },
    {
        title: 'Hotel Reservation',
        Icon: ApartmentIcon,
        path: '/dashboard/hotel-reservation',
        role: ['member'],
    },
    {
        title: 'Abstract Submission',
        Icon: DescriptionOutlinedIcon,
        path: '/dashboard/abstract-list',
        role: ['member'],
    },
    // {
    //     title: 'Participant',
    //     Icon: Icons.UserProfileIcon,
    //     role: ['operator'],
    //     children: [
    //     {
    //         name: 'List',
    //         path: '/dashboard/operator/user-list',
    //     },
    //     ],
    // },
    {
        title: 'Dashboard',
        Icon: Icons.DashboardIcon,
        path: '/dashboard/operator',
        role: ['operator', 'admin'],
    },
    {
        title: 'Registration',
        Icon: Icons.AccountSettingsIcon,
        path: '/dashboard/operator/registration',
        role: ['operator','admin','registrator']
    },
    {
        title: 'Check-In',
        Icon: Icons.AccountSettingsIcon,
        path: '/dashboard/operator/checkin',
        role: ['operator','admin','registrator']
    },
    {
        title: 'Submitted Abstract',
        Icon: DescriptionOutlinedIcon,
        role: ['admin', 'operator'],
        children: [
            {
                name: 'Submitted Abstract List',
                path: '/dashboard/operator/submitted-abstract',
            },
            {
                name: 'Approved Abstract',
                path: '/dashboard/operator/approved-abstract',
            },
            {
                name: 'Rejected Abstract',
                path: '/dashboard/operator/rejected-abstract',
            },
            {
                name: 'Final Score',
                path: '/dashboard/operator/final-score',
            },
        ],
    },
    {
        title: 'Invoice List',
        Icon: ReceiptLongRoundedIcon,
        path: '/dashboard/operator/invoice-list',
        role: ['admin', 'operator'],
    },
    {
        title: 'Hotel Invoices',
        Icon: ReceiptLongRoundedIcon,
        path: '/dashboard/operator/invoice-hotel',
        role: ['admin', 'operator'],
    },
    {
        title: 'Purchased Workshops',
        Icon: Icons.InvoiceIcon,
        path: '/dashboard/operator/purchased-workshops',
        role: ['admin','operator']
    },
    {
        title: 'Approval Group',
        Icon: Icons.InvoiceIcon,
        path: '/dashboard/operator/register-group-list',
        role: ['admin', 'operator'],
    },
    {
        title: 'Abstract Scoring',
        Icon: Icons.Email,
        role: ['judge'],
        children: [
            {
                name: 'Abstract To Score',
                path: '/dashboard/judge/abstract-to-score',
            },
            {
                name: 'Abstract Scored',
                path: '/dashboard/judge/abstract-scored',
            },
        ],
    },
    {
        title: 'Users',
        Icon: Icons.UserProfileIcon,
        role: ['admin'],
        children: [
            {
                name: 'List',
                path: '/dashboard/admin/user-list',
            },
            {
                name: 'Upload',
                path: '/dashboard/admin/user-upload',
            },
        ],
    },
    {
        title: 'Register Group',
        Icon: Icons.DataTableIcon,
        role: ['group'],
        children: [
            {
                name: 'Upload',
                path: '/dashboard/group-registration/upload',
            },
            {
                name: 'Data',
                path: '/dashboard/group-registration',
            },
        ],
    },
    {
        title: 'Setting',
        Icon: Icons.SettingIcon,
        role: ['admin'],
        children: [
            {
                name: 'Workshop',
                path: '/dashboard/admin/workshop',
            },
        ],
    },
];
export default index;
